/*
 * @Author: your name
 * @Date: 2022-01-10 18:45:27
 * @LastEditors: 聪Cong
 * @LastEditTime: 2022-01-10 20:26:03
 * @FilePath: /卫星/weixing/src/router/index.js
 */
import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../page/weixing.vue'
import Help from '../page/help.vue'
import dbmToW from '../page/dbm-to-W.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: '卫星角度',
    component: Home
  },
  {
    path: '/dbmToW',
    name: 'dbmToW',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: dbmToW
  },
  {
    path: '/help',
    name: '关于',
    component: Help
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
